"use strict";

exports.__esModule = true;
exports.WidgetGroup = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireWildcard(require("react"));
var _widgetGroups = require("../../Widgets/widgetGroups");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Core = require("../../Core");
var _Theme = require("../../Theme");
var _WidgetGroupDictionar;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var WidgetGroupContainer = _styledComponents["default"].div.withConfig({
  displayName: "WidgetGroup__WidgetGroupContainer",
  componentId: "sc-1m5uky8-0"
})(["width:100%;border-top:1px solid ", ";& > *:first-child{border-radius:0px !important;background-color:", " !important;width:100%;}& > *:last-child{border:none;}"], (0, _Theme.val)("borderColor"), (0, _Theme.val)("SecondaryToolbarBackground"));
var HeaderButton = (0, _styledComponents["default"])(_core.Button).withConfig({
  displayName: "WidgetGroup__HeaderButton",
  componentId: "sc-1m5uky8-1"
})(["word-break:break-all;justify-content:flex-start;"]);
var WidgetGroupDictionary = (_WidgetGroupDictionar = {}, _WidgetGroupDictionar[_widgetGroups.LAYOUT_WIDGET] = {
  translateKey: "WidgetGroupDictionary.Layout",
  defaultName: "Layout",
  icon: _icons.IconNames.GRID_VIEW
}, _WidgetGroupDictionar[_widgetGroups.ACTION_WIDGET] = {
  translateKey: "WidgetGroupDictionary.Action",
  defaultName: "Action",
  icon: _icons.IconNames.CUBE_ADD
}, _WidgetGroupDictionar[_widgetGroups.DEVICE_INFORMATION_WIDGET] = {
  translateKey: "WidgetGroupDictionary.DeviceInfo",
  defaultName: "Device Information",
  icon: _icons.IconNames.INFO_SIGN
}, _WidgetGroupDictionar[_widgetGroups.TIMELINE_WIDGET] = {
  translateKey: "WidgetGroupDictionary.Timeline",
  defaultName: "Timeline",
  icon: _icons.IconNames.INFO_SIGN
}, _WidgetGroupDictionar[_widgetGroups.DIGITAL_LOG_WIDGET] = {
  translateKey: "WidgetGroupDictionary.DigitalLog",
  defaultName: "Digital Log",
  icon: _icons.IconNames.TIMELINE_EVENTS
}, _WidgetGroupDictionar[_widgetGroups.OTHER_WIDGET] = {
  translateKey: "WidgetGroupDictionary.Other",
  defaultName: "Other",
  icon: _icons.IconNames.HELP
}, _WidgetGroupDictionar[_widgetGroups.RAW_DATA_WIDGET] = {
  translateKey: "WidgetGroupDictionary.RawData",
  defaultName: "Raw Data",
  icon: _icons.IconNames.CLOUD
}, _WidgetGroupDictionar[_widgetGroups.METRIC_WIDGET] = {
  translateKey: "WidgetGroupDictionary.Metric",
  defaultName: "Metric",
  icon: _icons.IconNames.TH
}, _WidgetGroupDictionar[_widgetGroups.KNOWLEDGE_BASE_WIDGET] = {
  translateKey: "WidgetGroupDictionary.KnowledgeBase",
  defaultName: "Knowledge Base",
  icon: _icons.IconNames.BOOK
}, _WidgetGroupDictionar);
var WidgetGroup = exports.WidgetGroup = function WidgetGroup(_ref) {
  var _WidgetGroupDictionar2;
  var widgetGroupKey = _ref.widgetGroupKey,
    children = _ref.children;
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var _useState = (0, _react.useState)(true),
    isOpen = _useState[0],
    setOpen = _useState[1];
  var _ref2 = (_WidgetGroupDictionar2 = WidgetGroupDictionary[widgetGroupKey]) != null ? _WidgetGroupDictionar2 : {},
    icon = _ref2.icon,
    defaultName = _ref2.defaultName,
    translateKey = _ref2.translateKey;
  return /*#__PURE__*/_react["default"].createElement(WidgetGroupContainer, {
    "data-testid": "WidgetGroup." + widgetGroupKey
  }, /*#__PURE__*/_react["default"].createElement(HeaderButton, {
    "data-testid": "WidgetGroup." + widgetGroupKey + ".button",
    minimal: true,
    onClick: function onClick() {
      return setOpen(!isOpen);
    },
    icon: icon
  }, translate(translateKey, defaultName)), isOpen ? children : null);
};